<template>
    <div>
        <div class="tab w-full overflow-hidden pb-5">

            <h3 @click="accordions.opened = !accordions.opened"  class="font-semibold uppercase flex justify-between items-center py-2 px-4 leading-normal cursor-pointer bg-primary text-white rounded-3xl">
                {{MONTHS[accordions.month-1]}} {{accordions.year}}
                <span v-if="accordions.opened" class="hover:bg-gray-500 rounded-full px-2 pb-1 text-xl font-bold text-white leading-none">–</span>
                <span v-else class="hover:bg-gray-500 rounded-full px-1.5 text-2xl font-bold text-white leading-none">+</span>
            </h3>
            <div :class="{'hidden':!accordions.opened, 'border-selected':accordions.opened, }" class="rounded-3xl tab-content overflow-hidden grid mt-1 items-center gap-y-2">
                <div class="p-4 bg-gray-50 rounded flex justify-between" v-for="(accordion, index) in accordions.moviments.filter( el => el.active == true)" :key="index">
                    <div class="flex flex-col">
                        <span class="uppercase size text-xs text-primary">{{DAYS[new Date(accordion.createdAt).getDay()]}}</span>
                        <strong class="font-semibold text-primary">{{new Date(accordion.createdAt).getDate()}}</strong>
                        <span class="uppercase text-xs text-primary">{{MONTHS[new Date(accordion.createdAt).getMonth()].substring(0, 3)}}</span>
                    </div>
                    <p class="mx-7 self-center text-left w-full">{{accordion.description}}</p>
                    <div class="self-center">
                        <p :class="setColorText(accordion.type)">{{setStringValue(accordion.value, accordion.type)}} pontos</p>
                    </div>
                </div>

                <!-- <p>{{accordions.description}}</p>

                <p class="font-semibold">{{accordions.pontos}}</p> -->
            </div>
        </div>
    </div>
</template>


<script>
import Fechar from "@/Components/UI/Icons/Fechar.vue"

export default{
    components:{ Fechar },
    props:{
        accordions:{
            type: Object,
            default: [],
        }
    },
    data(){
        return {
            DAYS : ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SAB"],
            MONTHS : [
                "Janeiro",
                "Fevereiro",
                "Março",
                "Abril",
                "Maio",
                "Junho",
                "Julho",
                "Agosto",
                "Setembro",
                "Outubro",
                "Novembro",
                "Dezembro",
            ]
        }
    },
    methods: {
        setColorText(type) {
            if(type == 'C') {
                return 'text-green-600'
            }
            if(type == 'D') {
                return 'text-red-500'
            }
        },
        setStringValue(value, type){
            value = parseInt(value);
            if(type == 'C') {
                return  `+${value}`
            }
            if(type == 'D') {
                return  `-${value}`
            }
        }
    }

};
</script>
